import {IntegrationTypeService} from "./service/api/integration-type.service";
import {IntegrationAdapterTypeService} from "./service/api/integration-adapter-type.service";
import {IntegrationTypeStepService} from "./service/api/integration-type-step.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const HC_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['hc.IntegrationTypeStepOutput', {route: '/hc/integrationTypeStepOutputs'}],
            ['hc.IntegrationSystemType', {route: '/hc/integrationSystemTypes'}],
            ['hc.IntegrationStep', {route: '/hc/integrationSteps'}],
            ['hc.IntegrationTypeStep', {route: '/hc/integrationTypeSteps', service: IntegrationTypeStepService}],
            ['hc.IntegrationType', {route: '/hc/integrationTypes', service: IntegrationTypeService}],
            ['hc.IntegrationAdapterType', {route: '/hc/integrationAdapterTypes', service: IntegrationAdapterTypeService}],
            ['hc.IntegrationTypeVariable', {route: '/hc/integrationTypeVariables'}],
            ['hc.IntegrationTransformationType', {route: '/hc/integrationTransformationTypes'}],
            ['hc.Integration', {route: '/hc/integrations'}],
            ['hc.DataHub', {route: '/hc/dataHubs'}],
            ['hc.IntegrationTypeStepTransition', {route: '/hc/integrationTypeStepTransitions'}],
            ['hc.IntegrationTypeStepInput', {route: '/hc/integrationTypeStepInputs'}],
            ['hc.IntegrationStepAdapter', {route: '/hc/integrationStepAdapters'}],

            ['hc.IntegrationAdapterTypeVariable', {route: '/hc/integrationAdapterTypeVariables'}],

        ] as EntityServiceEntry[],
        multi: true
    }
];
